import DOMPurify from 'dompurify';

/**
 * Sanitize untrusted or rich-text HTML using DOMPurify
 * @param {string} dirty - The raw HTML string
 * @param {object} options - Optional DOMPurify configuration options
 * @returns {string} Sanitized HTML safe for v-html
 */
export function sanitizeHtml(dirty, options = {}) {
    if (!dirty || typeof dirty !== 'string') return '';

    // Standard safe configuration for e-commerce rich text (CKEditor output)
    const defaultOptions = {
        ADD_ATTR: ['target', 'rel'],
        FORBID_TAGS: ['script', 'iframe', 'object', 'embed'],
        FORBID_ATTR: ['onerror', 'onload', 'onclick', 'onmouseover', 'onfocus', 'onblur']
    };

    return DOMPurify.sanitize(dirty, { ...defaultOptions, ...options });
}

export default sanitizeHtml;
